import { DimeButton, DimeCardShellSkeleton, DimeDetailPageStates } from '@nudool/design-system';
import { createFileRoute, Link } from '@tanstack/react-router';
import { TicketIcon } from 'lucide-react';

import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { PromotionCreditDetail } from '../../modules/promotion-credits/promotion-credit-detail.js';
import { usePromotionCreditDetail } from '../../modules/promotion-credits/use-promotion-credit-detail.js';

export const Route = createFileRoute('/credits/$creditId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: CreditDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function CreditDetailPage() {
  const { creditId } = Route.useParams();
  const detail = usePromotionCreditDetail(creditId);
  useBreadcrumbLabel(creditId, detail.credit?.creditMemoNumber ?? undefined);

  return (
    <DimeDetailPageStates
      data={detail.credit}
      loading={detail.loading}
      error={detail.error}
      entityLabel="Credit"
      notFoundIcon={<TicketIcon />}
      notFoundAction={
        <DimeButton variant="outline" asChild>
          <Link to="/credits">Back to credits</Link>
        </DimeButton>
      }
      skeleton={<DimeCardShellSkeleton factCount={0} actionCount={3} tabCount={3} rowCount={5} />}
      onRetry={() => void detail.refetchAll()}
    >
      {(credit) => (
        <PromotionCreditDetail
          credit={credit}
          lines={detail.lines}
          linesStatus={detail.linesStatus}
          onRetryLines={() => void detail.refetchLines().catch(() => undefined)}
          applications={detail.applications}
          onChanged={detail.refetchAll}
        />
      )}
    </DimeDetailPageStates>
  );
}
